import { ContentViewModel } from '@levelapp/softfabric';
import { Platform } from 'react-native';
import * as XLSX from 'xlsx';
export default class TableViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        this.imageDesc = require('./assets/sort_desc.png');
        this.imageAsc = require('./assets/sort_asc.png');
        this.image = require('./assets/sort.png');
        var tmp = "asc";
        if (this.props().defaultSortDesc != undefined && this.props().defaultSortDesc) {
            tmp = "desc";
        }
        this.initialState({
            DisplayTheSecondOptionColumn: false,
            IdOfTheRow: [],
            IdOfTheColumn: -1,
            AddingNewColumn: false,
            NewColumnValue: undefined,
            currentPage: 0,
            currentSort: tmp,
            defaultSortDesc: this.props().defaultSortDesc,
            isResearching: false,
            image: this.image,
            imageSort: undefined,
            sortIndice: -1,
            maximumId: 0,
            DisplayTheSecondOption: false,
            headers: this.props().headers != undefined && this.props().headers.length > 0 ? this.props().headers.slice(0) : ["Key"],
            currentArray: (this.props().data != undefined && this.props().data.length > 0) ? this.props().data.slice(0) : [],
            initialArrayState: (this.props().data != undefined && this.props().data.length > 0) ? this.props().data : [],
        });
        this.OnPress = this.OnPress.bind(this);
        this.sort = this.sort.bind(this);
        this.changePage = this.changePage.bind(this);
        this.TransformExcelToData = this.TransformExcelToData.bind(this);
        this.Researching = this.Researching.bind(this);
        this.ClosingResearch = this.ClosingResearch.bind(this);
        this.changePage = this.changePage.bind(this);
        this.TransformJSONToData = this.TransformJSONToData.bind(this);
        this.DeleteField = this.DeleteField.bind(this);
        this.AddANewRow = this.AddANewRow.bind(this);
        this.changeValue = this.changeValue.bind(this);
        this.AddANewColumn = this.AddANewColumn.bind(this);
    }
    /* METHODS */
    getCurrentArray() {
        return this.state().currentArray;
    }
    getHeaders() {
        return this.state().headers;
    }
    /* PAGING */
    getPages() {
        var tmp = this.getCurrentArray();
        if (tmp != undefined && tmp.length > 0) {
            return Math.ceil(tmp.length / this.props().numberItemsPerPage);
        }
        else {
            return 1;
        }
    }
    getElementsForPage() {
        // Slice Whithout Researching
        var page = this.getCurrentArray();
        if (page != undefined && page.length > 0) {
            page = page.slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage);
        }
        return page;
    }
    /* RESEARCH */
    Researching(txt) {
        if (txt == '' || txt == undefined) {
            this.setField({ isResearching: false, currentArray: this.state().initialArrayState.slice(0) });
        }
        else {
            if (this.state().initialArrayState != undefined && this.state().initialArrayState.length > 0) {
                this.changePage(0);
                this.setField({ isResearching: true, currentArray: this.state().initialArrayState.filter(x => {
                        if (x != undefined) {
                            return x.data.toString().toLocaleLowerCase().includes(txt.toLocaleLowerCase());
                        }
                    })
                });
            }
            else {
                this.setField({ isResearching: true });
            }
        }
    }
    ClosingResearch() {
        this.TransformIntialArrayToCurrentArray();
        this.setField({ isResearching: false });
    }
    changePage(nextPage) {
        this.setField({ currentPage: nextPage });
    }
    /* Export EXCEL */
    exportCSVFile() {
        /* The structure of parsing data to json to EXCEL is different that */
        /* the function exportyJSONFile() */
        /* Don't merge the 2 functions */
        var headers = this.state().headers;
        var jsonContent = [];
        this.state().currentArray.forEach((value, index, number) => {
            var element = "{";
            var key = "";
            var row = "";
            value.data.forEach((v, i, a) => {
                /* Structure { Key : key , fr : oui , en : yes } */
                if (i == 0) {
                    /* KEY */
                    row = " \"Key\" : " + "\"" + v + "\" ,";
                }
                else {
                    // "Language" : "Value" 
                    row += JSON.stringify(headers[i]) + ":" + JSON.stringify(v);
                    if (i != value.data.length - 1) {
                        // Add only when there is not the last row of a element.
                        row += ",";
                    }
                }
            });
            element = element + row;
            element += "}";
            console.log(element);
            jsonContent.push(JSON.parse(element));
        });
        var wb = XLSX.utils.book_new();
        var o = XLSX.utils.json_to_sheet(jsonContent, { header: this.state().headers });
        XLSX.utils.book_append_sheet(wb, o, "Translation");
        XLSX.writeFile(wb, "download.xlsx");
    }
    /* Export JSON */
    exportJSONFile() {
        if (Platform.OS == "web") {
            var FileSaver = require('file-saver');
            var headers = this.state().headers;
            var jsonContent = [];
            this.state().currentArray.forEach((value, index, number) => {
                var element = "{";
                var key = "";
                var row = "";
                value.data.forEach((v, i, a) => {
                    /* Structure Key : { fr : oui , en : yes } */
                    if (i == 0) {
                        /* KEY */
                        key = "\"" + v + "\"" + ":";
                    }
                    else {
                        // "Language" : "Value" 
                        row += JSON.stringify(headers[i]) + ":" + JSON.stringify(v);
                        if (i != value.data.length - 1) {
                            // Add only when there is not the last row of a element.
                            row += ",";
                        }
                    }
                });
                element = key + element;
                element += row;
                element += "}";
                jsonContent.push(element);
            });
            FileSaver.saveAs(new Blob(["{" + jsonContent + "}"], { type: "application/json;charset=utf-8" }), "download.json");
        }
    }
    handleFile(file) {
        this.handleReading(file);
    }
    handleReading(file) {
        if (file != undefined) {
            if (file.type && file.type.includes('json')) {
                //Read JSON file
                var fileReader = new FileReader();
                fileReader.onloadend = (e) => {
                    // Leave that
                    this.TransformJSONToData(fileReader.result);
                };
                fileReader.readAsText(file);
            }
            else {
                //Read Excel File
                var fileReader = new FileReader();
                fileReader.onloadend = (e) => {
                    // Leave that
                    var binary = "";
                    var bytes = new Uint8Array(fileReader.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    this.TransformExcelToData(binary);
                };
                fileReader.readAsArrayBuffer(file);
            }
        }
    }
    TransformJSONToData(results) {
        var array = JSON.parse(results);
        var tmp = [];
        var firstTime = true;
        var header = [];
        header.push("Key");
        var keyNumber = 0;
        for (var row in array) {
            var data = [];
            data.push(row);
            for (var cell in array[row]) {
                if (firstTime) {
                    header.push(cell);
                }
                data.push(array[row][cell]);
            }
            if (firstTime) {
                firstTime = false;
                this.setField({ headers: header });
            }
            tmp.push({ data: data, id: keyNumber });
            keyNumber++;
        }
        this.setField({ maximumId: keyNumber, currentArray: tmp, initialArrayState: tmp.slice(0) });
    }
    TransformExcelToData(data) {
        var headers = [];
        var workbook = XLSX.read(data, { type: "binary" });
        var range = XLSX.utils.decode_range(workbook.Sheets[workbook.SheetNames[0]]['!ref']);
        /* take the first from the row C */
        /* take the last of the row range.e.c */
        /* take the first row */
        var R = range.s.r;
        for (var C = range.s.c; C <= range.e.c; C++) {
            /* find the first cell in the first row */
            var cell = workbook.Sheets[workbook.SheetNames[0]][XLSX.utils.encode_cell({ c: C, r: R })];
            var hdr = "UNKNOWN";
            if (cell && cell.t)
                headers.push(hdr = XLSX.utils.format_cell(cell));
            /* if the value is a UNKNOWN, we reach the last value of the row */
            /* Without this check , it will continue loop a few times */
            if (hdr == "UNKNOWN") {
                break;
            }
        }
        var json = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
        var arrayToSend = [];
        var keyNumber = 0;
        json.forEach((v, i, array) => {
            var tmp = 0;
            var data = [];
            for (var tmp = 0; tmp < headers.length; tmp++) {
                /* Loop to the length of the header because of empty Translations
                /* Check if the key from the object is the same that the header */
                /* THERE CAN BE ERRORS IF THE HEADER OBJECT IS NOT A VALID FORMAT : "KEY , fr-BR , ... " !!! */
                if (v[headers[tmp]] != undefined) {
                    data.push(v[headers[tmp]]);
                }
                else {
                    data.push("");
                }
            }
            arrayToSend.push({ data: data, id: keyNumber });
            keyNumber++;
        });
        this.setField({ maximumId: keyNumber, headers: headers, currentArray: arrayToSend, initialArrayState: arrayToSend.slice(0) });
    }
    DisplayTheSecondChoice(currentId, arrayId) {
        this.setField({ DisplayTheSecondOption: true, IdOfTheRow: [currentId, arrayId] });
    }
    HideTheSecondChoice() {
        this.setField({ DisplayTheSecondOption: false, IdOfTheRow: [] });
    }
    DeleteField(currentKey, initialKey) {
        // Why 2 Properties?
        // Because I work with 2 different arrays. One is the initialArray for default sort and for research
        // And the second is the current array that is displayed. 
        // So when I remove a key, I need his reference in the initalarray and the currentarray.
        // initialKey is set in the 2 Transform functions while the currentKey is just the key of the displayed item.
        // The removing is not physical because it will modify the size of the initial array. I set the row at undefined.
        var tmp = this.state().currentArray;
        var tmpArray = this.state().initialArrayState;
        tmp.splice(currentKey, 1);
        tmpArray[initialKey] = undefined;
        this.setField((previousState) => previousState.currentArray = tmp);
        this.setField((previousState) => previousState.initialArrayState = tmpArray);
    }
    DeleteColumn(keyColumn) {
        console.log(keyColumn);
        var tmpHeaders = this.state().headers;
        var tmpArrayData = this.state().initialArrayState;
        tmpArrayData.forEach((value, index, array) => {
            if (value != undefined) {
                value.data.splice(keyColumn, 1);
            }
        });
        tmpHeaders.splice(keyColumn, 1);
        this.setField({ DisplayTheSecondOptionColumn: false, IdOfTheColumn: -1, currentArray: tmpArrayData, initialArrayState: tmpArrayData, headers: tmpHeaders });
    }
    DisplayTheSecondChoiceColumn(KeyColumn) {
        this.setField({ DisplayTheSecondOptionColumn: true, IdOfTheColumn: KeyColumn });
        setTimeout(() => { this.setField({ DisplayTheSecondOptionColumn: false, IdOfTheColumn: -1 }); }, 2000);
    }
    TransformIntialArrayToCurrentArray() {
        /* Use this function when you need to initialize the currentArray to the initialArray. */
        var tmpArray = this.state().initialArrayState;
        var tmp = [];
        tmpArray.forEach((value, index, array) => {
            if (value != undefined) {
                tmp.push(value);
            }
        });
        this.setField({ currentArray: tmp });
    }
    AddANewRow() {
        var headers = this.state().headers;
        var arrayTmp = [];
        // TODO User Key
        arrayTmp.push("Key");
        for (var i = 1; i < headers.length; i++) {
            arrayTmp.push("");
        }
        var currentTmpArray = this.state().currentArray.slice();
        currentTmpArray.push({ data: arrayTmp, id: this.state().maximumId });
        var initialTmpArray = this.state().initialArrayState.slice();
        initialTmpArray.push({ data: arrayTmp, id: this.state().maximumId });
        var number = this.state().maximumId;
        number++;
        this.setField({
            currentArray: currentTmpArray,
            initialArrayState: initialTmpArray,
            maximumId: number
        });
    }
    DisplayTheTextInputForColumn() {
        this.setField({ AddingNewColumn: true, NewColumnValue: undefined });
    }
    CancelAddingNewColumn() {
        this.setField({ AddingNewColumn: false, NewColumnValue: undefined });
    }
    ChangeColumnValue(column) {
        this.setField({ NewColumnValue: column });
    }
    AddANewColumn() {
        if (this.state().NewColumnValue != undefined) {
            var arrayTmp = this.state().initialArrayState;
            arrayTmp.forEach((value, index, array) => {
                if (value != undefined) {
                    value.data.push("");
                }
            });
            var headerTmp = this.state().headers;
            headerTmp.push(this.state().NewColumnValue);
            this.setField({ initialArrayState: arrayTmp, AddingNewColumn: false });
            this.TransformIntialArrayToCurrentArray();
        }
    }
    changeValue(value, text) {
        var tmp = value.split(";");
        this.setField((previousState) => previousState.currentArray[tmp[0]].data[tmp[1]] = text);
    }
    OnPress(key) {
        if (key != this.state().sortIndice) {
            if (this.props().defaultSortDesc != undefined && this.props().defaultSortDesc) {
                this.setField({ currentSort: 'desc', sortIndice: key, imageSort: this.imageDesc }, () => this.sort());
            }
            else {
                this.setField({ currentSort: 'asc', sortIndice: key, imageSort: this.imageAsc }, () => this.sort());
            }
        }
        else {
            this.setField({ sortIndice: key });
            if (this.props().defaultSortDesc != undefined && this.props().defaultSortDesc) {
                //First 
                //Desc - Asc - Default
                if (this.state().currentSort == 'desc') {
                    this.setField({ currentSort: 'asc', sortIndice: key, imageSort: this.imageAsc }, () => this.sort());
                }
                else if (this.state().currentSort == 'asc') {
                    this.setField({ currentSort: 'default', sortIndice: key, imageSort: this.image }, () => this.sort());
                }
                else if (this.state().currentSort == 'default') {
                    this.setField({ currentSort: 'desc', sortIndice: key, imageSort: this.imageDesc }, () => this.sort());
                }
            }
            else {
                //Second
                //Asc - Desc - Default
                if (this.state().currentSort == 'desc') {
                    this.setField({ currentSort: 'default', sortIndice: key, imageSort: this.image }, () => this.sort());
                }
                else if (this.state().currentSort == 'asc') {
                    this.setField({ currentSort: 'desc', sortIndice: key, imageSort: this.imageDesc }, () => this.sort());
                }
                else if (this.state().currentSort == 'default') {
                    this.setField({ currentSort: 'asc', sortIndice: key, imageSort: this.imageAsc }, () => this.sort());
                }
            }
        }
    }
    sort() {
        if (this.props().isSortable && this.state().sortIndice != -1) {
            //DESC-ASC-DEFAULT
            if (this.state().defaultSortDesc != undefined && this.state().defaultSortDesc && this.state().currentSort == 'asc') {
                this.setField({ arrayData: this.state().currentArray.sort((a, b) => { return a.data[this.state().sortIndice] < b.data[this.state().sortIndice] ? -1 : 1; }).slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage) });
            }
            else if (this.state().defaultSortDesc != undefined && this.state().defaultSortDesc && this.state().currentSort == 'desc') {
                this.setField({ arrayData: this.state().currentArray.sort((a, b) => { return a.data[this.state().sortIndice] > b.data[this.state().sortIndice] ? -1 : 1; }).slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage) });
            }
            else if (this.state().defaultSortDesc != undefined && this.state().defaultSortDesc && this.state().currentSort == 'default') {
                this.TransformIntialArrayToCurrentArray();
            }
            //ASC-DESC-DEFAULT
            if ((this.state().defaultSortDesc == undefined || this.state().defaultSortDesc == false) && this.state().currentSort == 'asc') {
                this.setField({ arrayData: this.state().currentArray.sort((a, b) => { return a.data[this.state().sortIndice] < b.data[this.state().sortIndice] ? -1 : 1; }).slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage) });
            }
            else if ((this.state().defaultSortDesc == undefined || this.state().defaultSortDesc == false) && this.state().currentSort == 'desc') {
                this.setField({ arrayData: this.state().currentArray.sort((a, b) => { return a.data[this.state().sortIndice] > b.data[this.state().sortIndice] ? -1 : 1; }).slice(this.state().currentPage * this.props().numberItemsPerPage, (this.state().currentPage + 1) * this.props().numberItemsPerPage) });
            }
            else if ((this.state().defaultSortDesc == undefined || this.state().defaultSortDesc == false) && this.state().currentSort == 'default') {
                this.TransformIntialArrayToCurrentArray();
            }
        }
    }
}
